import { withCompInfo } from '@wix/editor-elements-integrations'
import { RefComponentCss, RefComponentDefinition } from './RefComponent'
import _ from 'lodash'

export const css = withCompInfo<RefComponentCss, RefComponentDefinition>()(
	['hasResponsiveLayout', 'compProps', 'experiments'],
	({ hasResponsiveLayout, compProps, experiments }, additionalData) => {
		const childHasResponsiveLayout = _.get(additionalData, ['childData', 'childHasResponsiveLayout'], false)
		const minHeight = compProps.minHeight
		const minHeightCss = minHeight ? { 'min-height': `${minHeight}px` } : {}

		// nested grids = bad performance
		const renderAsDisplayBlock = experiments['specs.thunderbolt.displayRefComponentsAsBlock']
		const displayValue = renderAsDisplayBlock && !minHeight ? 'block' : 'grid'

		return !hasResponsiveLayout && childHasResponsiveLayout
			? { ...minHeightCss, '--display': displayValue, display: 'var(--display)' }
			: {}
	}
)
